<template>
  <node-view-wrapper
    as="span"
    class="link-underline editable-shorttag-inline"
  >
    <node-view-content as="span">
      <router-link-simple
        :to="node.attrs.to"
        :title="node.attrs.title"
        :target="node.attrs.target ? '_blank' : ''"
        :rel="node.attrs.rel"
      >
        {{ node.attrs.text }}
      </router-link-simple>
    </node-view-content>
    <standard-link-btn
      btn-type="update"
      :title-prop="node.attrs.title"
      :to-prop="node.attrs.to"
      :target-prop="node.attrs.target"
      @update-content="tiptapContentUpdate"
    />
  </node-view-wrapper>
</template>

<script>
import {
  NodeViewWrapper,
  NodeViewContent,
  nodeViewProps,
} from '@tiptap/vue-2';
import RouterLinkSimple from '../RouterLinkSimple.vue';
import StandardLinkBtn from './StandardLinkBtn.vue';

export default {
  name: 'StandardLinkShorttag',
  components: {
    NodeViewWrapper,
    NodeViewContent,
    RouterLinkSimple,
    StandardLinkBtn,
  },
  props: {
    ...nodeViewProps,
  },
  methods: {
    tiptapContentUpdate(updateData) {
      this.updateAttributes(updateData.attrs);
    },
  },
};
</script>

